var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.22 20.9432C40.22 19.5605 40.0959 18.231 39.8655 16.9546H21.5V24.5064H31.9945C31.5336 26.935 30.1509 28.9914 28.0768 30.3741V35.2846H34.4055C38.0927 31.881 40.22 26.8819 40.22 20.9432Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 39.9999C26.765 39.9999 31.1791 38.2627 34.4054 35.2845L28.0768 30.374C26.3395 31.544 24.1236 32.2531 21.5 32.2531C16.43 32.2531 12.1223 28.8317 10.58 24.2227H4.0918V29.2572C7.30043 35.6213 13.8773 39.9999 21.5 39.9999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.58 24.2048C10.19 23.0348 9.95954 21.7939 9.95954 20.4998C9.95954 19.2057 10.19 17.9648 10.58 16.7948V11.7603H4.09182C2.76227 14.3839 2 17.3443 2 20.4998C2 23.6553 2.76227 26.6157 4.09182 29.2393L9.14409 25.3039L10.58 24.2048Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.76455C24.3718 8.76455 26.9245 9.75727 28.9632 11.6718L34.5473 6.08773C31.1613 2.93227 26.765 1 21.5 1C13.8773 1 7.30043 5.37864 4.0918 11.7605L10.58 16.795C12.1223 12.1859 16.43 8.76455 21.5 8.76455Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d46703b6ed038c258845dd7d5be8411d.svg";
export { ForwardRef as ReactComponent };